import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
// import axios from "axios";
import useCalculateSimilarity from "../hooks/useCalculateSimilarity";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

import WordsTrEngCard from "../Component/WordsTrEngCard";
import AsistanCard from "../Component/AsistanCard";
import StudentCard from "../Component/StudentCard";
import HeaderCard from "../Component/HeaderCard";
import NextButton from "../Component/NextButton";
import BackButton from "../Component/BackButton";
import CelebrationComponent from "../Component/Celebrate";
import ArrayCounter from "../Component/ArrayCounter";
import QuestionCard from "../Component/QuestionCard";
import StoryCrad from "../Component/StoryCrad";

function Reading() {
  const [TextValue, setTextValue] = useState(0);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [activeLevel, setActiveLevel] = useState("verbs");
  const [isTeacherTurn, setIsTeacherTurn] = useState(true);
  const [isListening, setIsListening] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [transcript, setTranscript] = useState("");
  const [isCorrect, setIsCorrect] = useState(false);
  const [similarityScore, setSimilarityScore] = useState(0);
  const [taskPackage, setTaskPackage] = useState({});
  const [finish, setFinish] = useState(false);
  const [readingVerb, setReadingVerb] = useState([]);
  const [readingStroy, setReadingStroy] = useState(null);
  const [readingQuestion, setReadingQuestion] = useState([]);
  const [userAnswers, setUserAnswers] = useState([]);
  const [completePart, setCompletePart] = useState(false);
  const [repeatVerbsCount, SetRepeatVerbsCount] = useState({});
  const [selectedOptions, setSelectedOptions] = useState({});

  // Eksik olan error ve recognition state'leri eklendi
  const [error, setError] = useState("");
  const [recognition, setRecognition] = useState(null);

  const mediaRecorderRef = useRef(null);
  const audioChunksRef = useRef([]);
  const isProcessingRef = useRef(false);

  const levelSet = [
    { name: "verbs", tr: "fiiller" },
    { name: "Story", tr: "hikaye" },
    { name: "Questions", tr: "sorular" },
    { name: "Exıt", tr: "cıkış" },
  ];

  // Redux'tan gelen veriyi alıyoruz
  const reading_1 = useSelector((state) => state.contents.contentValues);
  const navigate = useNavigate();

  useEffect(() => {
    if (!reading_1 || reading_1.length === 0) {
      console.log("İçerik boş, ana sayfaya yönlendiriliyor...");
      navigate("/");
    }
  }, [reading_1, navigate]);

  useEffect(() => {
    if (reading_1) {
      setReadingVerb(reading_1.verbs || []);
      setReadingStroy(reading_1.Articles || null);
      setReadingQuestion(reading_1.Questions || []);
    }
  }, [reading_1]);

  useEffect(() => {
    setTaskPackage({
      userAnswers: userAnswers,
      repeatVerbsCount: repeatVerbsCount,
    });
  }, [completePart, userAnswers, repeatVerbsCount]);

  // Yeni soru/seviyeye geçerken başlangıç durumunu ayarla
  useEffect(() => {
    setIsTeacherTurn(true);
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
    setError("");
  }, [TextValue, activeLevel]);

  const { calculateSimilarity, getFeedbackMessage, getSimilarityColor } =
    useCalculateSimilarity();

  // --- Web Speech API Entegrasyonu ---
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      setError(
        "Your browser does not support Speech Recognition. Please use Google Chrome or Microsoft Edge.",
      );
      return;
    }

    const recognitionInstance = new SpeechRecognition();
    recognitionInstance.continuous = false;
    recognitionInstance.interimResults = false;
    recognitionInstance.lang = "en-US";

    recognitionInstance.onresult = (event) => {
      const spokenText = event.results[0][0].transcript;
      setTranscript(spokenText);

      // Aktif seviyeye göre hedef metni doğru seçiyoruz
      const target =
        activeLevel === "verbs"
          ? readingVerb[TextValue]?.Eng
          : readingStroy?.Story;

      if (!target) return;

      // Benzerlik skoru hesaplama
      const score = calculateSimilarity(spokenText, target);
      setSimilarityScore(score);

      // %50 ve üzeri başarı kontrolü
      if (score >= 0.6) {
        setIsCorrect(true);
        setTimeout(() => goToNext(), 1500);
      } else {
        setIsCorrect(false);
      }
    };

    recognitionInstance.onerror = (event) => {
      setError(`Error occurred in recognition: ${event.error}`);
      setIsListening(false);
    };

    recognitionInstance.onend = () => {
      setIsListening(false);
    };

    setRecognition(recognitionInstance);

    return () => {
      if (recognitionInstance) {
        recognitionInstance.abort();
      }
    };
  }, [TextValue, activeLevel, readingVerb, readingStroy]);

  // Güvenli veri kontrolü (Loading durumunu belirler)
  const isDataReady =
    readingVerb.length > 0 &&
    readingStroy !== null &&
    readingQuestion.length > 0;

  if (!isDataReady) {
    return (
      <div className="flex justify-center items-center h-64 text-xl font-semibold text-purple-600">
        Yükleniyor...
      </div>
    );
  }

  const currentReadingVocabulary = readingVerb[TextValue] || {};
  const currentReadingStroy = readingStroy;
  const currentReadingQuestion = readingQuestion[questionIndex] || {};
  const currentContentText =
    activeLevel === "verbs"
      ? currentReadingVocabulary?.Eng
      : currentReadingStroy?.Story;

  // TTS: Asistan Konuşması
  const speakText = (text) => {
    if (!text) return;
    window.speechSynthesis.cancel();
    setIsSpeaking(true);
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.onend = () => {
      setIsSpeaking(false);
      setTimeout(() => setIsTeacherTurn(false), 150);
    };
    window.speechSynthesis.speak(utterance);
  };

  const handleAnswerSelect = (option) => {
    const currentQuestion = readingQuestion[questionIndex];
    if (!currentQuestion || selectedOptions[questionIndex] !== undefined)
      return;

    const isCorrectAns = option === currentQuestion.answer;

    setSelectedOptions((prev) => ({
      ...prev,
      [questionIndex]: option,
    }));

    setUserAnswers((prev) => [
      ...prev,
      {
        questionId: currentQuestion._id,
        question: currentQuestion.question,
        givenAnswer: option,
        correctAnswer: currentQuestion.answer,
        isCorrect: isCorrectAns,
      },
    ]);
  };

  // Düzeltilen startListening fonksiyonu
  const startListening = () => {
    setError("");
    setIsCorrect(false);
    setTranscript("");
    setSimilarityScore(0);
    setIsTeacherTurn(false);

    if (recognition) {
      try {
        recognition.start();
        setIsListening(true);
      } catch (err) {
        console.error("Recognition start error:", err);
      }
    }
  };

  const handleLevelChange = (level) => {
    if (level === "Exıt") {
      setActiveLevel(level);
      setTextValue(0);
      setTranscript("");
      setIsCorrect(false);
      setSimilarityScore(0);
      navigate("/");
      return;
    }
    setActiveLevel(level);
    setTextValue(0);
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
  };

  const goToNext = () => {
    if (activeLevel === "verbs") {
      const nextValue = TextValue + 1;
      if (nextValue < readingVerb.length) {
        setTextValue(nextValue);
      } else {
        setActiveLevel("Story");
        setTextValue(0);
      }
    } else if (activeLevel === "Story") {
      setActiveLevel("Questions");
      setSelectedOptions({});
    } else if (activeLevel === "Questions") {
      const nextQuestion = questionIndex + 1;
      if (nextQuestion >= readingQuestion.length) {
        setFinish(true);
        setCompletePart(true);
      } else {
        setQuestionIndex(nextQuestion);
      }
    }
  };

  const goToBack = () => {
    if (activeLevel === "verbs") {
      const prevValue = TextValue - 1;
      if (prevValue >= 0) {
        setTextValue(prevValue);
        return;
      }
      setActiveLevel("Questions");
      setSelectedOptions({});
      return;
    }

    if (activeLevel === "Story") {
      setActiveLevel("verbs");
      return;
    }

    if (activeLevel === "Questions") {
      const prevQuestion = questionIndex - 1;
      if (prevQuestion >= 0) {
        setQuestionIndex(prevQuestion);
        return;
      }
      setActiveLevel("Story");
    }
  };

  return (
    <div
      className="flex flex-col w-full gap-4"
      style={{ fontFamily: "Inter, system-ui, -apple-system, sans-serif" }}
    >
      {/* Hata Bildirimi */}
      {error && (
        <div className="p-3 bg-red-100 text-red-700 rounded-xl text-sm border border-red-200">
          {error}
        </div>
      )}

      {/* celebrate */}
      <div className={completePart ? "block" : "hidden"}>
        {completePart && (
          <CelebrationComponent
            setCompletePart={setCompletePart}
            taskPackage={taskPackage}
          />
        )}
      </div>

      {/* reading */}
      <div className={completePart ? "hidden" : "block flex-col gap-4 w-full"}>
        {/* Header */}
        <div className="w-full mb-4">
          <HeaderCard
            handleLevelChange={handleLevelChange}
            levelSet={levelSet}
            activeLevel={activeLevel}
          />
        </div>

        {/* contents */}
        <div className="w-full flex flex-col gap-4 p-2 bg-purple-500 rounded-xl">
          <div>
            <div className="flex justify-between items-center  ">
              <BackButton handleBackButton={goToBack} finish={finish} />
              <div>
                {activeLevel === "verbs" && (
                  <ArrayCounter TextValue={TextValue} activeLevel="verbs" />
                )}
                {activeLevel === "Questions" && (
                  <ArrayCounter
                    TextValue={questionIndex}
                    activeLevel="Questions"
                  />
                )}
              </div>

              <NextButton handleNextButton={goToNext} />
            </div>

            <div
              className="w-full bg-gradient-to-br from-purple-500 to-purple-500
               py-3 md:py-10 flex justify-center items-center flex-row gap-3 md:gap-8 "
            >
              <div className="flex flex-col justify-center items-center xl:flex-row gap-6 xl:gap-8">
                {activeLevel === "Story" && (
                  <StoryCrad
                    isTeacherTurn={isTeacherTurn}
                    currentReadingStroy={currentReadingStroy}
                  />
                )}
                {activeLevel === "verbs" && (
                  <div className="text-6xl md:text-8xl drop-shadow-lg">
                    {currentReadingVocabulary.emoji}
                  </div>
                )}
                {activeLevel === "Story" && (
                  <div className="text-6xl md:text-8xl drop-shadow-lg">
                    {currentReadingStroy.emoji}
                  </div>
                )}
                {activeLevel === "verbs" && (
                  <WordsTrEngCard TextValue={TextValue} activeLevel="verbs" />
                )}

                {activeLevel === "Story" && (
                  <div
                    className={`${isTeacherTurn ? "bg-gray-200" : "bg-white"} ${isTeacherTurn ? "border-gray-400" : "border-yellow-500"} border-l-4 rounded-2xl p-4 md:p-6 shadow-xl hover:shadow-2xl transition-all w-full md:w-auto`}
                  >
                    <div>
                      <span
                        className={`inline-block px-3 py-1 ${isTeacherTurn ? "bg-transparent" : "bg-purple-100"} font-semibold rounded-lg text-md md:text-lg mb-2 ${isTeacherTurn ? "text-gray-400" : "text-purple-700"}`}
                      >
                        {currentReadingStroy.Baslık}
                      </span>
                      <p className="text-md md:text-md text-gray-700 leading-relaxed">
                        {currentReadingStroy.metin}
                      </p>
                    </div>
                  </div>
                )}

                {activeLevel === "Questions" && (
                  <QuestionCard
                    TextValue={questionIndex}
                    handleAnswerSelect={handleAnswerSelect}
                    selectedOption={selectedOptions[questionIndex]}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Konuşma kartları */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 w-full">
            {activeLevel === "verbs" && (
              <AsistanCard
                isTeacherTurn={isTeacherTurn}
                speakText={speakText}
                isSpeaking={isSpeaking}
                TextValue={TextValue}
                activeLevel={activeLevel}
              />
            )}
            {activeLevel === "Story" && (
              <AsistanCard
                isTeacherTurn={isTeacherTurn}
                speakText={speakText}
                isSpeaking={isSpeaking}
                TextValue={TextValue}
                activeLevel={activeLevel}
              />
            )}
            {activeLevel === "verbs" && (
              <StudentCard
                isCorrect={isCorrect}
                TextValue={TextValue}
                startListening={startListening}
                isTeacherTurn={isTeacherTurn}
                isListening={isListening}
                transcript={transcript}
                similarityScore={similarityScore}
                getFeedbackMessage={getFeedbackMessage}
                getSimilarityColor={getSimilarityColor}
                activeLevel={activeLevel}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reading;
